import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const IconDownload = React.forwardRef<SVGSVGElement, any>((props, ref) => {
  return (<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 20 20" fill="none" className="icon-download" data-icon="icon-download" aria-hidden="true" {...props} ref={ref}><path d="M9.99935 14.1667V2.5M9.99935 14.1667L4.99935 9.16667M9.99935 14.1667L14.9993 9.16667M15.8327 17.5H4.16602" stroke="currentColor" strokeLinecap="square" strokeLinejoin="round"/></svg>);
});

IconDownload.displayName = 'IconDownload';
